export enum TaskStatus {
    NOT_READY = 'not_ready',
    PENDING = 'pending',
    READY = 'ready',
    IN_PROGRESS = 'in_progress',
    BLOCKED = 'blocked',
    WAITING = 'waiting',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
}

export enum WaitingOnReason {
    MEMBER = 'member',
    ACCOUNTING = 'accounting',
    EXTERNAL = 'external',
    ENGINEERING = 'engineering',
}

export const OperatorTaskTemplateName = {
    DOCUMENT_UPLOAD_REQUEST: 'document_upload_request',
    MEMBER_QUESTIONNAIRE: 'member_questionnaire',
    SIGN_SS4: 'sign_ss4',
    // The operator-facing catch-all: its context schema accepts anything, which is why agents and
    // devtools reach for it when the work has no template of its own.
    ADHOC_TASK: 'adhoc_task',
    // Raised by the Taxfyle OPEN_ITEMS webhook, not by anyone here: one task per (member, year)
    // carding every document the tax pro asked for. The individual asks are TaxfyleDocumentRequest
    // rows, which is what the requested-documents panel edits.
    MEMBER_UPLOAD_ITR_DOCUMENTS: 'member_upload_itr_documents',
} as const;

export type FormationOwner = 'VENDOR' | 'INTERNAL';

export interface OperatorTaskContext {
    cta_url?: string;
    action_description?: string;
    notes?: string;
    /** Set only on the file_llc, confirm_llc and file_ein formation milestones. */
    formation_owner?: FormationOwner;
    [key: string]: unknown;
}

export interface OperatorTaskResources {
    cta_url?: string;
}

export interface OperatorTaskSubmitAction {
    type: 'upload' | 'redirect' | 'form' | 'custom';
    label: string;
    url?: string;
    is_external?: boolean;
    component_name?: string;
}

export interface OperatorTaskDismissAction {
    type: 'cancel' | 'defer';
    label: string;
}

export interface OperatorTaskTemplate {
    id: string;
    name: string;
    display_name: string;
    instructions: string;
    sla_hours: number;
    tools: Record<string, any>;
    resources: OperatorTaskResources;
    is_member_task: boolean;
    submit_action: OperatorTaskSubmitAction;
    dismiss_action: OperatorTaskDismissAction;
    dismissable: boolean;
    location: string[];
    has_custom_component: boolean;
}

export interface OperatorTask {
    id: string;
    status: TaskStatus;
    priority: number;
    context: OperatorTaskContext;
    task_template: OperatorTaskTemplate;
    task_type: string;
    source: string;
    task_labels: string[];
    due_date: string;
    flagged: boolean;
    is_in_sla: boolean;
    effective_sla_hours: number;
    created_at: string;
    updated_at: string;
}

// Minimal shape the provider reads, so it accepts either OperatorTask or the member-tasks Task.
export interface TaskLike {
    id: string;
    status: string;
    task_type?: string;
    task_template: { name: string };
}
